import _regeneratorRuntime from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/seva/Developer/strategy_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * Created by AAravindan on 5/7/16.
 */
import { LinkedList } from "./LinkedList";

var FixedSizeLinkedList =
/*#__PURE__*/
function (_LinkedList) {
  _inherits(FixedSizeLinkedList, _LinkedList);

  function FixedSizeLinkedList(size, maintainHigh, maintainLow, maintainSum) {
    var _this;

    _classCallCheck(this, FixedSizeLinkedList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FixedSizeLinkedList).call(this));
    _this.size = size;
    _this.maintainHigh = maintainHigh;
    _this.maintainLow = maintainLow;
    _this.maintainSum = maintainSum;
    _this.totalPushed = 0;
    _this.periodHigh = 0;
    _this.periodLow = Infinity;
    _this.periodSum = 0;

    if (!size || typeof size !== "number") {
      throw new Error("Size required and should be a number.");
    }

    _this._push = _this.push;

    _this.push = function (data) {
      _this.add(data);

      _this.totalPushed++;
    };

    return _this;
  }

  _createClass(FixedSizeLinkedList, [{
    key: "add",
    value: function add(data) {
      if (this.length === this.size) {
        this.lastShift = this.shift();

        this._push(data); // TODO: FInd a better way


        if (this.maintainHigh) {
          if (this.lastShift === this.periodHigh) {
            this.calculatePeriodHigh();
          }
        }

        if (this.maintainLow) {
          if (this.lastShift === this.periodLow) {
            this.calculatePeriodLow();
          }
        }

        if (this.maintainSum) {
          this.periodSum = this.periodSum - this.lastShift;
        }
      } else {
        this._push(data);
      } // TODO: FInd a better way


      if (this.maintainHigh) {
        if (this.periodHigh <= data) {
          this.periodHigh = data;
        }
      }

      if (this.maintainLow) {
        if (this.periodLow >= data) {
          this.periodLow = data;
        }
      }

      if (this.maintainSum) {
        this.periodSum = this.periodSum + data;
      }
    }
  }, {
    key: "iterator",
    value:
    /*#__PURE__*/
    _regeneratorRuntime.mark(function iterator() {
      return _regeneratorRuntime.wrap(function iterator$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              this.resetCursor();

            case 1:
              if (!this.next()) {
                _context.next = 6;
                break;
              }

              _context.next = 4;
              return this.current;

            case 4:
              _context.next = 1;
              break;

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, iterator, this);
    })
  }, {
    key: "calculatePeriodHigh",
    value: function calculatePeriodHigh() {
      this.resetCursor();

      if (this.next()) {
        this.periodHigh = this.current;
      }

      while (this.next()) {
        if (this.periodHigh <= this.current) {
          this.periodHigh = this.current;
        }
      }
    }
  }, {
    key: "calculatePeriodLow",
    value: function calculatePeriodLow() {
      this.resetCursor();

      if (this.next()) {
        this.periodLow = this.current;
      }

      while (this.next()) {
        if (this.periodLow >= this.current) {
          this.periodLow = this.current;
        }
      }
    }
  }]);

  return FixedSizeLinkedList;
}(LinkedList);

export { FixedSizeLinkedList as default };